import uuid from 'uuid/v4'
import { EXACT_MATCH } from '@edulastic/constants/const/evaluationType'
import { cloneDeep, isEmpty } from 'lodash'

import { itemStructure, Q_TYPES } from '../constants'
import { AI_DOK_TO_PA_DOK_VALUES_MAP } from '../../constants'
import { getAlignmentForEduItems } from '../helpers'
import { getDefaultDataByQuestionType } from './getQuestionDefaultData'

export const processShortText = (
  {
    name,
    options,
    commonCoreStandard,
    depthOfKnowledge,
    difficultLevel,
    autoGeneratedQuestionAlignment,
  },
  alignmentData,
  grades,
  subjects,
  aiDocExtracted = false
) => {
  const { type, title, ...restData } = cloneDeep(
    getDefaultDataByQuestionType(Q_TYPES.SHORT_TEXT)
  )

  const alignment = !isEmpty(autoGeneratedQuestionAlignment?.[0])
    ? autoGeneratedQuestionAlignment
    : getAlignmentForEduItems(alignmentData, commonCoreStandard)

  const item = cloneDeep(itemStructure)
  if (aiDocExtracted) {
    item.aiDocExtracted = true
  }

  item._id = uuid()
  const qId = uuid()

  const [row] = item.rows

  const widget = {
    widgetType: 'question',
    title,
    type,
    reference: qId,
    tabIndex: 0,
  }
  row.widgets.push(widget)

  const responses = options.map((option) => ({
    score: 1,
    value: option.name,
    matchingRule: EXACT_MATCH,
  }))

  const validation = {
    scoringType: EXACT_MATCH,
    validResponse: responses[0],
    altResponses: [],
  }

  return {
    ...item,
    data: {
      questions: [
        {
          ...restData,
          id: qId,
          title,
          type,
          stimulus: name,
          uiStyle: {
            type: 'standard',
          },
          validation,
          multipleResponses: false,
          hints: [],
          itemScore: 1,
          alignment,
          grades,
          subjects,
          ...(AI_DOK_TO_PA_DOK_VALUES_MAP[depthOfKnowledge]
            ? {
                depthOfKnowledge: AI_DOK_TO_PA_DOK_VALUES_MAP[depthOfKnowledge],
              }
            : {}),
          authorDifficulty: difficultLevel,
        },
      ],
      resources: [],
    },
  }
}
